import React from 'react';
import { Sparkles } from 'lucide-react';
import { Reveal } from '../ui/Reveal';
const benefits = [{
  title: 'Imaginá saber exactamente qué hacer cada día para ayudar a tu hijo a hablar más.',
  desc: 'Sin improvisar. Sin buscar en Google a las 11 de la noche. Sin dudar si lo que estás haciendo sirve. Con un plan claro, organizado por etapas, que te dice exactamente qué actividad hacer hoy.'
}, {
  title: 'Imaginá terminar cada día con la tranquilidad de saber que hiciste algo importante por el desarrollo del habla de tu hijo.',
  desc: 'Solo 10 minutos alcanzan para dejar de preguntarte si podrías estar haciendo más. Porque ahora seguís un método claro, pensado para cada etapa.'
}, {
  title: 'Imaginá escuchar una palabra nueva y saber que estuviste ahí para ayudar a que sucediera.',
  desc: 'Ese momento en el que tu hijo te sorprende con una palabra, una frase o un pedido que antes no podía hacer. Y vos sabés que cada pequeño avance empezó con esos 10 minutos que compartieron todos los días.'
}, {
  title: 'Imaginá ir a la reunión familiar del domingo sin miedo a los comentarios.',
  desc: '"El primo habla más." "¿No lo llevaste al fonoaudiólogo?" "En mi época no se hacía todo esto." Y vos, tranquila, porque entendés el proceso de tu hijo y sabés cómo acompañarlo.'
}, {
  title: 'Imaginá llegar al jardín de infantes con un hijo que puede pedir lo que necesita, hacer amigos y comunicarse con la maestra.',
  desc: 'No porque sea un genio. Sino porque tuvo a alguien que lo acompañó desde el primer día con las herramientas correctas.'
}];
export function Benefits() {
  return <section className="py-12 px-5 bg-violet-600 text-white" data-id="element-20">
      <div className="flex items-center justify-center gap-2 mb-8" data-id="element-21">
        <Sparkles className="w-6 h-6 text-violet-200" data-id="element-22" />
        <h2 className="text-3xl font-bold text-center" data-id="element-23">Imaginá esto:</h2>
        <Sparkles className="w-6 h-6 text-violet-200" data-id="element-24" />
      </div>

      <div className="space-y-8" data-id="element-25">
        {benefits.map((benefit, index) => <Reveal key={index} delay={Math.min(index * 0.05, 0.2)} data-id="element-26">
            <div className="relative pl-6 border-l-2 border-violet-400" data-id="element-27">
              <div className="absolute -left-[9px] top-1 w-4 h-4 rounded-full bg-violet-300 border-4 border-violet-600" data-id="element-28" />
              <h3 className="font-bold text-xl mb-2 text-violet-50" data-id="element-29">
                {benefit.title}
              </h3>
              <p className="text-violet-200 leading-relaxed" data-id="element-30">{benefit.desc}</p>
            </div>
          </Reveal>)}
      </div>

      <div className="mt-12 text-center bg-violet-700/50 p-6 rounded-2xl backdrop-blur-sm" data-id="element-31">
        <p className="text-xl font-bold text-white" data-id="element-32">
          Todo eso es posible con 10 minutos diarios. Y empieza hoy.
        </p>
      </div>
    </section>;
}